<template>
  <div class="d-flex">
    <!-- CARD SIMPLE PLACEHOLDER IMAGE FILTERS -->
    <v-card flat outlined class="ma-0 pa-0 mr-1" style="min-width: 48px">
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricImageFiltersGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB SIMPLE PLACEHOLDER IMAGE FILTER -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          :style="
            $vuetify.breakpoint.width > 410
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
          @click="changeImageFilter"
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1"
              >mdi-image-filter-vintage</v-icon
            >
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricFiltersFilter") }}
            </div></v-card-title
          >
        </v-card>

        <v-spacer></v-spacer>
        <!-- GUMB SIMPLE PLACEHOLDER BRIGHTNESS FILTER -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              :style="
                $vuetify.breakpoint.width > 410
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
              v-on="on"
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon color="accent" class="mt-1"
                  >mdi-lightbulb-on-outline</v-icon
                >
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
                ><div class="headerClass">
                  {{ $t("fabricFiltersBrightness") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="imageSettings.brightness"
                class="align-center"
                :max="1"
                :min="-1"
                :step="0.05"
                hide-details
                vertical
                @change="changeImageBrightness"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB SIMPLE PLACEHOLDER BLUR FILTER -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              :style="
                $vuetify.breakpoint.width > 410
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
              v-on="on"
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon color="accent" class="mt-1">mdi-contrast</v-icon>
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
                ><div class="headerClass">
                  {{ $t("fabricFiltersContrast") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="imageSettings.contrast"
                class="align-center"
                :max="1"
                :min="-1"
                :step="0.05"
                hide-details
                vertical
                @change="changeImageContrast"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB SIMPLE PLACEHOLDER FILTERS REMOVE -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          :style="
            $vuetify.breakpoint.width > 410
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
          @click="removeImageFilters"
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-filter-remove</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricFiltersReset") }}
            </div></v-card-title
          >
        </v-card>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { fabric } from "fabric";

export default {
  name: "fabric-simple-placeholder-image-controls-card",
  props: {
    template: {
      type: Object,
      required: true,
    },
    imageSettings: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    iIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    changeImageFilter() {
      fabric.textureSize = 8192; // da ne cropa slik pri filtru

      // če je bil prazen filter, sedaj skočimo direktno na prvega
      if (this.imageSettings.filter == 0) this.imageSettings.filter = 1;

      // replace filter
      let ind = -1;
      ind = this.template.canvas
        .getActiveObject()
        .item(this.index)
        .filters.findIndex((x) => x.fName == "classicFilter");

      if (ind > -1)
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.splice(ind, 1);

      let filterStr = "";

      if (this.imageSettings.filter == 1) {
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.push(
            new fabric.Image.filters.Grayscale({ fName: "classicFilter" })
          );
        filterStr = this.$t("fabricImageFilterGrayscale");
      } else if (this.imageSettings.filter == 2) {
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.push(
            new fabric.Image.filters.Vintage({ fName: "classicFilter" })
          );
        filterStr = this.$t("fabricImageFilterVintage");
      } else if (this.imageSettings.filter == 3) {
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.push(
            new fabric.Image.filters.Brownie({ fName: "classicFilter" })
          );

        filterStr = this.$t("fabricImageFilterBrownie");
      } else if (this.imageSettings.filter == 4) {
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.push(
            new fabric.Image.filters.Sepia({ fName: "classicFilter" })
          );
        filterStr = this.$t("fabricImageFilterSephia");
      } else if (this.imageSettings.filter == 5) {
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.push(
            new fabric.Image.filters.Kodachrome({ fName: "classicFilter" })
          );
        filterStr = this.$t("fabricImageFilterKodachrome");
      } else {
        filterStr = this.$t("fabricImageFilterNoFilter");
      }

      this.$store.commit({
        type: "showSnackbar",
        color: "accent",
        message: this.$t("fabricImageFilterBase") + ": " + filterStr,
      });

      if (this.imageSettings.filter >= 5) {
        this.imageSettings.filter = 0;
      } else this.imageSettings.filter++;

      this.template.canvas.getActiveObject().item(this.index).applyFilters();
      this.template.canvas.requestRenderAll();
    },
    changeImageBrightness() {
      fabric.textureSize = 8192; // da ne cropa slik pri filtru

      // replace filter
      let ind = -1;
      ind = this.template.canvas
        .getActiveObject()
        .item(this.index)
        .filters.findIndex((x) => x.fName == "brightnessFilter");

      if (ind > -1)
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.splice(ind, 1);

      //this.template.canvas.getActiveObject().item(1).filters = [];
      this.template.canvas
        .getActiveObject()
        .item(this.index)
        .filters.push(
          new fabric.Image.filters.Brightness({
            brightness: this.imageSettings.brightness,
            fName: "brightnessFilter",
          })
        );
      this.template.canvas.getActiveObject().item(this.index).applyFilters();
      this.template.canvas.requestRenderAll();
    },
    changeImageContrast() {
      fabric.textureSize = 8192; // da ne cropa slik pri filtru

      // replace filter
      let ind = -1;
      ind = this.template.canvas
        .getActiveObject()
        .item(this.index)
        .filters.findIndex((x) => x.fName == "contrastFilter");

      if (ind > -1)
        this.template.canvas
          .getActiveObject()
          .item(this.index)
          .filters.splice(ind, 1);

      //this.template.canvas.getActiveObject().item(1).filters = [];
      this.template.canvas
        .getActiveObject()
        .item(this.index)
        .filters.push(
          new fabric.Image.filters.Contrast({
            contrast: this.imageSettings.contrast,
            fName: "contrastFilter",
          })
        );
      this.template.canvas.getActiveObject().item(this.index).applyFilters();
      this.template.canvas.requestRenderAll();
    },
    removeImageFilters() {
      this.template.canvas.getActiveObject().item(this.index).filters = [];
      this.template.canvas.getActiveObject().item(this.index).applyFilters();
      this.template.canvas.requestRenderAll();

      this.imageSettings.filter = 0;
      this.imageSettings.brightness = 0;
      this.imageSettings.contrast = 0;
    },
  },
};
</script>

<style scoped>
.hover-item {
  cursor: pointer;
}
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
}
</style>